import { render } from "./ExchangeHistory.vue?vue&type=template&id=f9b773b8&scoped=true&ts=true"
import script from "./ExchangeHistory.vue?vue&type=script&lang=ts"
export * from "./ExchangeHistory.vue?vue&type=script&lang=ts"

import "./ExchangeHistory.vue?vue&type=style&index=0&id=f9b773b8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b773b8"]])

export default __exports__